/**
 * The tab bar look (web restyle, 2026-10-28): a pill track on the card surface, the selected tab
 * a blue-filled pill. Styles only; each tab bar keeps its own elements, roles and behaviour.
 */
import type { CSSProperties } from 'react';

/** The track around a row of tabs. */
export const TAB_TRACK_STYLE: CSSProperties = {
  display: 'inline-flex',
  flexWrap: 'wrap',
  gap: '4px',
  padding: '4px',
  borderRadius: 'var(--radius-pill)',
  backgroundColor: 'var(--color-bg-secondary)',
};

/** One tab: blue-filled when selected, plain text otherwise. */
export function tabPillStyle(selected: boolean): CSSProperties {
  return {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    height: '36px',
    padding: '0 16px',
    border: 'none',
    borderRadius: 'var(--radius-pill)',
    backgroundColor: selected ? 'var(--color-accent-blue)' : 'transparent',
    color: selected ? 'var(--color-on-accent)' : 'var(--color-text-secondary)',
    fontSize: '14px',
    fontWeight: selected ? 600 : 500,
    textDecoration: 'none',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
  };
}
